module.exports = __webpack_public_path__ + "static/fonts/D-DINExp.e3e8c080.otf";